<template>
  <div>
    <template>

      <a class="routerLink hidden-md-and-down"
         @click="redirect('my-profile')"
      >

        <v-icon class="pr-2">mdi-account</v-icon>
        <strong>@{{name}}</strong>

      </a>


      <v-list-item
          class="hidden-lg-and-up"
          @click="redirect('my-profile')"
      >
        <v-list-item-icon>
          <v-avatar
              class="pb-2"
              size="33"
          >
            <v-icon>mdi-account</v-icon>
          </v-avatar>
        </v-list-item-icon>
        <v-list-item-title class="pl-2">@{{name}}</v-list-item-title>

      </v-list-item>

    </template>

  </div>
</template>

<script>

import Axios from "axios";
import i18n from "../i18n.js";
import Session from "@/services/Session";

export default {
  props: ["drawer"],
  data () {
    return {
      name: '',
      show: false,
    }
  },
  methods: {
    redirect(href){
      this.$router.push('/'+ i18n.locale + '/' + href)
    }
  },
  created (){
    let session = Session.getSession()
    if(session !== null) {
      this.name = session.username
    }
  },
  components: { }
}
</script>